<template>
  <div class="analyzes-chart">
    <h2 class="d-block">{{$t('analyzes.progress')}}</h2>
    <div class="row">
      <div class="col-9">
        <div  v-if="loading" class="text-center mt-5 d-flex justify-content-center">
          <b-spinner

              variant="primary"
          ></b-spinner>
        </div>
        <v-select
            v-show="!loading"
            v-model="selectedChart"
            class="chart-select"
            :placeholder="$t('analyzes.select_placeholder')"
            label="title"
            @input="changeChart()"
            :options="analyzesChartList"/>

        <div class="dates my-3" v-if="!loading && chartData.length > 0 && selectedChart !== null">
          <p class="date-research">
            {{ $t('analyzes.date')}}: {{ getResearchDate.researchDateLast }}
          </p>
          <p class="date-previous-research" v-if="getResearchDate.researchDatePreLast">
            {{ $t('analyzes.date_prev')}}: {{ getResearchDate.researchDatePreLast }}
          </p>
        </div>

        <div v-if="!loading && chartData.length > 0 && selectedChart !== null" class="item row " role="button"
             v-for="(item,index) in chartData" @click="toChart(index)">
          <div class="col-10 d-flex justify-content-start flex-column ">
            <p class="chart-item-name mt-3" style="">
              {{ item['Marker'] }}
            </p>
            <p v-if="item['Data'][item['Data'].length - 2 ]">
              {{ $t('analyzes.previous') }}: {{ item['Data'][item['Data'].length - 2]['Value'] }}
            </p>

          </div>

          <div class="col-2 d-flex align-items-center justify-content-end">
            <div class="research-value text-center"
                 :class="item['Data'][item['Data'].length - 1]['IsWithinReferenceRange'] ? 'green-border':'red-border'">
              {{ item['Data'][item['Data'].length - 1]['Value'] }}
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import moment from 'moment'

export default {
  data() {
    return {
      selectedChart: null,
      loading: false,
    };
  },
  computed: {
    ...mapGetters([
      'analyzes',
      'analyzesChartList',
      'chartData',
      'selectedAnalyzeItem'
    ]),
    getResearchDate() {
      let date = {
        researchDateLast: '',
        researchDatePreLast: '',
      }

      if (this.chartData.length) {
        let items = this.chartData[0]['Data']

        if (items.length > 1) {
          let lastItem = items[items.length - 1]
          let preLastItem = items[items.length - 2]

          date.researchDateLast = moment(lastItem['Date']).format('DD.MM.YY')
          date.researchDatePreLast = moment(preLastItem['Date']).format('DD.MM.YY')
        } else {
          let lastItem = items[items.length - 1]
          date.researchDateLast = moment(lastItem['Date']).format('DD.MM.YY')
        }

      }
      return date
    },
  },

  methods: {
    changeChart() {
      this.loading = true
      this.$store
          .dispatch('getAnalyzesChart', this.selectedChart).then(() => this.loading = false)
    },
    toChart(idx) {
      this.$router.push({
        name: 'profile.analyzes.detail.chart',
        query: {chart_id: this.selectedChart.id, marker_id: idx}
      })
    },
  },
  mounted() {
    this.loading = true
    this.$store
        .dispatch('getAnalyzesChartList').then(() => {
          if(this.selectedAnalyzeItem){
            this.selectedChart = this.selectedAnalyzeItem
          }

      this.loading = false
    });
  },
}
</script>

<style lang="scss">
.analyzes {
  & > h2 {
    font-size: 42px;
    color: #0a4766;
    margin-top: 25px;
  }

  & > .item {
    min-height: 90px;

    &:not(:first-child) {
      border-bottom: 2px solid rgba(163, 190, 204, 0.25);
    }

    & > .download {
      & > *:not(:last-child) {
        margin-right: 10px;
      }
    }

    &:last-child {
      border-bottom: none;
    }
  }

  iframe.content {
    width: 100%;
    min-height: 75vh;
  }
}
</style>
